/*jshint esversion: 8 */
import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { observer } from "mobx-react";
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import Selection from './Selection';
import Table from './Table';
import AddDialog from './AddDialog';
import UpdateDialog from './UpdateDialog';
import ColumnFilterDialog from './FilterDialog';
import Functions from "./Functions";
import { tableFieldsConfig } from './data';
import LocalStore from "./LocalStore";
import { getLocalStorageFieldWithFieldName, updateLocalStorageFields } from '../../../utils/LocalStorageHandler';
import store from "../../../components/stores/Store";

const styles = {
  root: {
    '& .MuiTextField-root': {
      margin: '10px',
      width: '25ch',
    },
  },
};

class ComfortableHousing extends Component {
  constructor() {
    super();
    this.state = {
      login: true,
    };
  }

  async componentDidMount() {
    const newTableFieldsConfig = tableFieldsConfig;
    const comfortableHousingTableFilter = getLocalStorageFieldWithFieldName('comfortableHousingTableFilter');
    if (comfortableHousingTableFilter) {
      for (let index = 0; index < newTableFieldsConfig.length; index++) {
        const element = newTableFieldsConfig[index];
        const cacheDisplay = comfortableHousingTableFilter[element.sid];
        if (cacheDisplay === true || cacheDisplay === false) {
          newTableFieldsConfig[index].display = cacheDisplay;
        }
      }
    }
    LocalStore.set({ tableFields: newTableFieldsConfig });
    document.title = "安置房住户明细表";
  }

  render() {
    const { classes } = this.props;
    // if (LocalStore.tableFields.length === 0) return null;
    return (
      <div className={classes.root}>
        <Typography variant="h5" gutterBottom>
          安置房住户明细表
        </Typography>
        <Selection functions={Functions} />
        <Table functions={Functions} />
        <AddDialog functions={Functions} />
        <UpdateDialog functions={Functions} />
        <ColumnFilterDialog />
      </div>
    );
  }
}

const ComfortableHousingObserver = observer(ComfortableHousing);

ComfortableHousingObserver.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ComfortableHousingObserver);